module.exports = __webpack_public_path__ + "2c88cc3ff379744d1242da4c5544a13f.svg";